import React from 'react'

const Footer = () => {
  return (
    <footer>
      <div className='footer-container'>
        <p>Projet realise par Tsiory - 2023 - du cours ReactJS de DonkeyGeek</p>
        <p>Les icones Wolverine, Iron-man, Spider-man, Batman sont prises sur iconFinder.com</p>
      </div>
    </footer>
  )
}

export default Footer